import React, { useContext, useEffect, useState } from "react";
import { FilterContext } from "../../context/Filter";
import { fetchsixqtytablePVIN } from "./PvinKip";

const SixMonthsQuantityPvin = () => {
  const [sixMonthQtyData, setSixMonthQtyData] = useState([]);
  const { superArn, childArn } = useContext(FilterContext);

  // 🔹 Check URL first
  const urlParams = new URLSearchParams(window.location.search);
  const vinFromUrl = urlParams.get("vin");
  // console.log(vinFromUrl, "urrll")
  // 🔹 Decide final ARN value
  const finalArn = vinFromUrl || childArn || superArn;

  // 🔹 Payload: if superArn comes via URL → still sent as `arn`
  const payload1 = finalArn ? { arn: finalArn } : null;

  const fetchSixMonthQuantity = async () => {
    try {
      const response = await fetchsixqtytablePVIN(payload1);

      const formattedData =
        response?.map((item) => ({
          dealerName: item.key[0] || "-",
          ppl: item.key[1] || "-",
          pl: item.key[2] || "-",
          date: item.key[3] || "-",
          count: item.doc_count || 0,
        })) || [];

      setSixMonthQtyData(formattedData);
    } catch (error) {
      console.error("Error fetching six month quantity data:", error);
    }
  };

  useEffect(() => {
    if (finalArn) {
      fetchSixMonthQuantity();
    }
  }, [finalArn]);

  return (
    <div className="overflow-x-auto mt-4">
      <table className="min-w-full border border-gray-300 rounded-lg shadow-md text-sm">
        <thead className="bg-[#007BC0] text-white">
          <tr>
            <th className="px-6 py-3 border text-center font-semibold">
              Dealer Name
            </th>
            <th className="px-6 py-3 border text-center font-semibold">PPL</th>
            <th className="px-6 py-3 border text-center font-semibold">PL</th>
            <th className="px-6 py-3 border text-center font-semibold">Date</th>
            <th className="px-6 py-3 border text-center font-semibold">Count</th>
          </tr>
        </thead>
        <tbody>
          {sixMonthQtyData.length > 0 ? (
            sixMonthQtyData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-3 border text-center">
                  {item.dealerName}
                </td>
                <td className="px-6 py-3 border text-center">{item.ppl}</td>
                <td className="px-6 py-3 border text-center">{item.pl}</td>
                <td className="px-6 py-3 border text-center">{item.date}</td>
                <td className="px-6 py-3 border text-center">{item.count}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4 text-gray-500 border">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SixMonthsQuantityPvin;
